import { Filter } from '../constants/types';

export const areFiltersEqual = (filterA: Filter, filterB: Filter) =>
  filterA.name === filterB.name
        && filterA.comparator === filterB.comparator
        && filterA.filteredValues === filterB.filteredValues;

export default { areFiltersEqual };
